import type { User, SystemRole, UpdateUserInput, CreateUserInput } from '@peles/shared';
import { apiClient } from './client';

export async function createUser(data: CreateUserInput): Promise<User> {
  const { data: user } = await apiClient.post<User>('/users', data);
  return user;
}

export async function listUsers(filters?: {
  isActive?: boolean;
  systemRole?: SystemRole;
}): Promise<User[]> {
  const params = new URLSearchParams();
  if (filters?.isActive !== undefined) params.set('isActive', String(filters.isActive));
  if (filters?.systemRole) params.set('systemRole', filters.systemRole);

  const { data } = await apiClient.get<User[]>('/users', { params });
  return data;
}

export async function getUser(id: string): Promise<User> {
  const { data } = await apiClient.get<User>(`/users/${id}`);
  return data;
}

export async function updateUser(id: string, updates: UpdateUserInput): Promise<User> {
  const { data } = await apiClient.patch<User>(`/users/${id}`, updates);
  return data;
}

export async function deactivateUser(id: string): Promise<User> {
  const { data } = await apiClient.delete<User>(`/users/${id}`);
  return data;
}
